const SalesInvoiceReportFooter = () => {
  return (
    <div className="__footer">
      <table width="100%">
        <tbody>
          <tr>
            <td style={{ height: 0 }} width="33.33%" >
              <MyCard heading="Return Instructions">
                <p>
                  1) No return will be accepted without RA#.<br />
                  2) All Return must include a copy of this packing list.<br />
                  3) Only approved styles and Quantities are returnable against this RA.<br />
                  4) Returns will not be accepted if merchandise has a sensor on it.<br />
                  5) Return will not be accepted after expire date.<br />
                  6) Only Credit Memo will be issued for returned goods - no refund.<br />
                  7) There will be a deduction of 5% if the returned unit is missing waist tag.<br />
                  8) Returns without an advance shipping notice (including tracking#) and an approved RA# will not be processed.
                </p>
              </MyCard>
            </td>
            <td style={{ height: 0 }} width="33.33%" className='__footer_col_2' />
            <td style={{ height: 0 }} width="33.33%" >
              <MyCard heading="Return Address">
                <p>
                  Bergen Shippers DLPD Canada LTD c/o Bergen Logistics<br />
                  3925 Steeles Ave East UNIT # 3 Brampton, ON L6T 5W5<br />
                  Contact Person : Mary Williams<br />
                  Tel: 905 792 8585 Ext.25
                </p>
              </MyCard>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default SalesInvoiceReportFooter;

const MyCard = ({ heading, children }) => (
  <div className="__card">
    {heading && <h4
      style={{
        display: "flex",
        justifyContent: "center",
        textDecoration: "underline",
      }}
    >{heading}</h4>}
    {children}
  </div>
)